// src/pages/MisReunionesPage.tsx
import React from 'react';
import CalendarioReuniones from '../../../components/CalendarioReuniones/CalendarioReuniones';

const MisReunionesPage: React.FC = () => {
  return <CalendarioReuniones soloUsuarioActual />;
};

export default MisReunionesPage;
